import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LeftOutlined } from '@ant-design/icons';

const BackLink = ({ to = '/', label = null, preventHistory = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toLabel = label || t('common.back');

  const handleClick = (e) => {
    e.preventDefault();

    // if there's meaningful history and we're not preventing history, go back
    if (window.history.length > 2 && !preventHistory) {
      navigate(-1);
    } else {
      // When preventing history, just navigate without replace
      navigate(to);
    }
  };

  return (
    <a href={to} onClick={handleClick}>
      <LeftOutlined style={{ marginRight: 4 }} />
      <span>{toLabel}</span>
    </a>
  );
};

export default BackLink;
